import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["passwordField", "emailField", "emailLabel"]

  toggle(event) {
    const checked = event.target.checked
    this.passwordFieldTarget.classList.toggle("hidden", !checked)
    const passwordInput = this.passwordFieldTarget.querySelector("input")
    if (checked) {
      passwordInput?.setAttribute("required", "required")
    } else {
      passwordInput?.removeAttribute("required")
    }
    if (this.hasEmailFieldTarget) {
      if (checked) {
        this.emailFieldTarget.setAttribute("required", "required")
      } else {
        this.emailFieldTarget.removeAttribute("required")
      }
    }
    if (this.hasEmailLabelTarget) {
      this.emailLabelTarget.textContent = checked ? "Email *" : "Email (optional)"
    }
  }
}
